module.exports = __webpack_public_path__ + "img/logo@2x.ee7c432.svg";